type FullPageLoaderProps = {
  message?: string;
};

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ message }) => {
  return (
    <div className="full-page-loader-backdrop">
      <div className="loader-container">
        {/* Outer rotating ring */}
        <div className="loader-ring loader-ring-1"></div>
        {/* Middle rotating ring */}
        <div className="loader-ring loader-ring-2"></div>
        {/* Inner pulsing circle */}
        <div className="loader-core"></div>
        {/* Floating particles */}
        <div className="loader-particle loader-particle-1"></div>
        <div className="loader-particle loader-particle-2"></div>
        <div className="loader-particle loader-particle-3"></div>
        <div className="loader-particle loader-particle-4"></div>
        <div className="loader-particle loader-particle-5"></div>
        <div className="loader-particle loader-particle-6"></div>
      </div>
      <div className="loader-text">Loading...</div>
      <div className="loader-text">{message}</div>
    </div>
  );
};

export default FullPageLoader;
